import { Stack } from '@mui/material';
import { BackLink } from '~/components/back-link/back-link';
import { MOBILE_BOTTOM_GAP, NAVBAR_HEIGHT } from '~/components/shell/layout';
import { TipsPanel } from './tips-panel';

export const DicasScreen = () => {
  return (
    <Stack spacing={2} px={3} py={4}>
      <BackLink />
      <TipsPanel showScrollIndicator stickyBottomOffset={NAVBAR_HEIGHT + MOBILE_BOTTOM_GAP} />
    </Stack>
  );
};
